export const NUMERIC_DATA_TYPES = ['number','quantity','currency'];
export const GST_REG_EX_PATTERN = /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[CZ]{1}[0-9a-zA-Z]{1}$|^[0-9]{4}[a-zA-Z]{3}[0-9]{5}[uUnN]{2}[0-9a-zA-Z]{1}$/; 
export const PAN_REG_EX_PATTERN = /[A-Z]{3}[PCFTGHLABJ]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}/; 
export const VENDOR_CATEGORIES = [
    {id:1,label:'All'},
    {id:2,label:'Parts & Accessories'},
    {id:3,label:'Tyres'},
    {id:4,label:'Battery'},
    {id:5,label:'Care & Decor'},
    {id:6,label:'Compliance'},
    {id:7,label:'Others'},
];

export const PAYMENT_TERMS = [
    {id:1,label:'Advance Payment'},
    {id:2,label:'Credit'},
    {id:3,label:'Cash On Delivery'}
];

export const PAYMENT_MODE = [
    {id:1,label:'Amount'},
    {id:2,label:'Percentage (%)'},
];

export const PERIOD_MODE = [
    {id:1,label:'Day'},
    {id:2,label:'Week'},
    {id:3,label:'Month'},
    {id:4,label:'Year'}
];

export const IMPORT_PROCESS_STATUS = [
    {status:1,statusText:'Pending',className:'partial'},
    {status:2,statusText:'File Uploaded',className:'partial'},
    {status:3,statusText:'File Upload Failed',className:'partial'},
    {status:4,statusText:'Processing',className:'partial'},
    {status:5,statusText:'Partially Updated',className:'partial'},
    {status:6,statusText:'Updated',className:'partial'},
    {status:7,statusText:'Update Failed',className:'partial'},
];

export const DATETIME_FORMATTER = "DD-MMM-YY, ddd, hh:mm A";
export const DATE_FORMATTER = "DD-MMM-YY, ddd";
export const DATEONLY_FORMATTER = "DD-MMM-YY";

export const PO_STATUS = [
    {id:1,label:'Open'},
    {id:2,label:'Send'},
    {id:3,label:'Fulfilled'},
    {id:4,label:'Part Fulfilled'},
    {id:5,label:'Cancelled'},
    {id:6,label:'Shortclosed'},
    {id:7,label:'TBA'},
]
